export default "__VITE_ASSET__JndJWtPX__"